export const ANALYTICS_EVENTS_ACTIONS = {
	JOB_EVENT_CREATED: "job_event_created",
	JOB_CHAT_MOUNTED: "job_chat_mounted",
	JOB_CHAT_ERROR_RETRIEVING_ACTIVE_JOBS: "job_chat_error_retrieving_active_jobs",
	REPORT_REQUESTED: "report_requested",
	REPORT_EXPORTED: "report_exported",
	UI_CRASH: "ui_crash",
};

export const ANALYTICS_EVENTS_CATEGORIES = {
	CREATE_JOB_EVENT: "create_job_event",
	JOB_CHAT: "job_chat",
	REPORT_REQUEST: "report_request",
	REPORT_EXPORT: "report_export",
	JOB_CHAT_OPENED: "job_chat_opened",
};



